import config from "./config";

export default class IBA {
    static linkToQuote(quoteEntryId) {
        if (typeof quoteEntryId === 'string') {
            return config.iba.url + "/Quotes/editQuote.action?quote.id=" + quoteEntryId?.split("-")?.[0]?.slice(-10);
        }
    }

    static linkToPolicy(policyId) {
        if (typeof policyId === 'string') {
            return config.iba.url + "/Policies/editPolicy.action?policy.id=" + policyId?.slice(-10);
        }
    }

    static linkToCustomer(customerId) {
        return config.iba.url + "/Customers/editCustomer.action?customer.customerNumber=" + customerId;
    }

    static linkToProduct(productId) {
        return config.iba.url + "/Products/editProduct.action?product.id=" + parseInt(productId?.slice(-10));
    }
}
